import { Routes, Route } from "react-router";
import loadable from "@loadable/component";

import { path, getTailOfPath } from "utils/(path)";
import { Loader } from "components/@common/Loader/Loader";

export default function CrownRouter() {
  const PATH_DEEP = 2;

  const CrownMainPage = loadable(() => import("./main"), { fallback: <Loader /> });
  const CrownResultPage = loadable(() => import("./result"), { fallback: <Loader /> });
  return (
    <Routes>
      <Route path={getTailOfPath(path.crown(), PATH_DEEP)} element={<CrownMainPage />} />
      <Route path={getTailOfPath(path.crownResult(null), PATH_DEEP)} element={<CrownResultPage />} />
    </Routes>
  );
}
